import { useContext } from 'react';
import * as R from 'ramda';

import ElementInfoBox from '@atom/components/common/moveElement/ElementInfoBox';
import { Icon, IconButton } from '@atom/mui';
import { CheckCircleIcon, CloseIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import ReplaceElementModalContext from './ReplaceElementModalContext';

import classes from './replaceElement.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
  successIcon: {
    fontSize: '56px',
  },
};

interface Props {
  onCloseModal: () => void;
}

const SuccessView = ({ onCloseModal }: Props) => {
  const {
    element,
    destinationAssetPath,
    replacementAsset,
    replacementAssetPath,
    rootAsset,
  } = useContext(ReplaceElementModalContext);

  const fromMoveElementDisplay = element.ancestors
    .map(item => item.name)
    .join(' / ');
  const toMoveElementDisplay = destinationAssetPath
    .map(item => item.name)
    .join(' / ');
  const toMoveRootAssetId = R.head(destinationAssetPath)?.id;

  const fromReplacementElementDisplay = R.dropLast(
    1,
    replacementAssetPath.map(item => item.name),
  ).join(' / ');
  const toReplacementElementDisplay = element.ancestors
    .map(item => item.name)
    .join(' / ');
  const fromReplacementRootAssetId = R.head(replacementAssetPath)?.id;

  return (
    <div className={classes.successView}>
      <div className={classes.successClose}>
        <IconButton
          onClick={onCloseModal}
          data-cy="replaceElementSuccessCloseButton"
        >
          <Icon icon={CloseIcon} />
        </IconButton>
      </div>
      <div className={classes.successIcon}>
        <Icon
          style={styles.successIcon}
          color={colors.brand.green}
          icon={CheckCircleIcon}
        />
        <div className={classes.iconBackground} />
      </div>
      <div className={classes.successTitle}>Sub Item Moved Successfully</div>
      <ElementInfoBox
        element={replacementAsset}
        fromAssetDisplay={fromReplacementElementDisplay}
        fromAssetId={fromReplacementRootAssetId}
        toAssetDisplay={toReplacementElementDisplay}
        toAssetId={rootAsset.id}
        isReplaceElement
        pastTense
      />
      <ElementInfoBox
        element={element}
        fromAssetDisplay={fromMoveElementDisplay}
        fromAssetId={rootAsset.id}
        toAssetDisplay={toMoveElementDisplay}
        toAssetId={toMoveRootAssetId}
        pastTense
      />
    </div>
  );
};

export default SuccessView;
